<template>
    <search-group  :span="24" :btnOffset="18" :btnSpan="6" :multipleLines="true" :inline="true"   @search="findData" @clear="clearValue" >
        <Row class="mb16" :gutter="16">
            <Col span="3">
                 <Select v-model="searchData.projectFid" placeholder="请选择项目">
                   <Option value=''>请选择</Option>
                    <Option value = '100' v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
            <Col span="3">
                 <Select v-model="searchData.surType" placeholder="解约类型" >
                    <Option value=''>请选择</Option>
                    <Option v-for="item in surTypeEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
            <Col span="3">
                 <Select v-model="searchData.surStatus" placeholder="解约协议状态">
                   <Option value=''>请选择</Option>
                    <Option v-for="item in surrenderStatuseEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
            <Col span="3">
              <Select v-model="searchData.leaseTime" placeholder="出租类型">
                <Option value=''>请选择</Option>
                <Option v-for="item in leaseTimeeEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="6">
                <DatePicker split-panels v-model="surReleaseDate" type="daterange" format="yyyy-MM-dd" @on-change="changeTerminationDay" placeholder="解约日"></DatePicker>
          </Col>
          <Col span="6">
            <DatePicker split-panels v-model="surApplicationDate" placement="bottom-end" type="daterange" format="yyyy-MM-dd" @on-change="changeApplyDay" placeholder="解约申请日"></DatePicker>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="4">
            <Select v-model="searchData.surMode" placeholder="解约方式">
              <Option value=''>请选择</Option>
              <Option v-for="item in surModeEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </Col>
          <Col span="4">
            <Select v-model="searchData.surAuditType" placeholder="审核类型">
              <Option value=''>请选择</Option>
              <Option v-for="item in surrenderAuditTypeEnum" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </Col>

          <Col span="4">
            <Select v-model="searchData.balanceStatus" placeholder="结算状态">
              <Option value=''>请选择</Option>
              <Option v-for="item in surrenderBalanceEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </Col>
          <Col span="3">
            <Select v-model="key" placeholder="关键字查询">
              <Option value=''>请选择</Option>
              <Option v-for="item in keyList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </Col>
          <Col span="5">
            <Input type="text" v-model="keyValue" placeholder="请输入" @keyup.enter.native="findData"></Input>
          </Col>
        </Row>
    </search-group>
</template>

<script type="text/ecmascript-6">

import SearchGroup from 'components/SearchGroup/index';

export default {
    props:{
      projectList:{
        type:Array,
        default(){
          return []
        }
      },
      surModeEnums:{
        type:Array,
        default(){
          return []
        }

      },
      surrenderAuditTypeEnum:{
        type:Array,
        default(){
          return []
        }
      },
      leaseTimeeEnums:{
        type:Array,
        default(){
          return []
        }
      },
      surrenderStatuseEnums:{
        type:Array,
        default(){
          return []
        }
      },
      surrenderBalanceEnums:{
        type:Array,
        default(){
          return []
        }

      },
      surTypeEnums:{
        type:Array,
        default(){
          return []
        }
      }
    },
    watch:{
        projectList(val) {
            if (val && val.length) {
                this.searchData.projectFid = val[0].value
            }
        }
    },
    components: {
        SearchGroup
    },
    data () {
      return {
        loading:false,
        surReleaseDate:[],
        surApplicationDate:[],
        key:'',
        keyValue:'',
        keyList:[
          {
            value:'contractCode',
            text:'签约合同号'
          },
          {
            value:'surCode',
            text:'解约协议号'
          },
          {
            value:'customerName',
            text:'解约客户'
          },
          {
            value:'userPhone',
            text:'签约手机号'
          },
          {
            value:'stockNumber',
            text:'房间号'
          },
          {
            value:'handleZo',
            text:'解约ZO'
          }
        ],
        searchData:{
          surMode:'',
          balanceStatus:'',
          projectFid:'',
          surType:'',
          surStatus:'',
          leaseTime:'',
          surReleaseStartDate:'',
          surReleaseEndDate:'',
          surApplicationStartDate:'',
          surApplicationEndDate:'',
          limit: 10,
          page: 1,
          surAuditType: ''
        }
      }
    },
    methods: {
      findData() {
        let key = this.key
        let value = this.keyValue
        let data = {}

        if(key && value) {
          data[key] = value
        }
         data = Object.assign({},data, this.searchData);
        this.$emit('findData',data)
      },
    changeTerminationDay(val){
      this.searchData.surReleaseStartDate = val[0]
      this.searchData.surReleaseEndDate = val[1]
    },
    changeApplyDay(val){
      this.searchData.surApplicationStartDate = val[0]
      this.searchData.surApplicationEndDate = val[1]
    },
    clearValue() {
      this.searchData.page = 1
      for( let key in this.searchData) {
        if(key === 'page' || key === 'limit') {
          continue
        }else {
          this.searchData[key] = ''
        }
      }
      this.surReleaseDate=[]
      this.surApplicationDate = []
      this.key = ''
      this.keyValue = ''
    }
    }
}
</script>
<style scoped>
.dash {
  text-align: center;
}
.dash span {
  display: inline-block;
  width: 60%;
  height: 2px;
  background: #dddee1;
  vertical-align: middle;
}
.ivu-date-picker {
  width: 100%;
}
</style>

